var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assets-type"},[_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.buildAssets.length !== 0),expression:"buildAssets.length !== 0"}]},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"assets-items"},_vm._l((_vm.buildAssets),function(item,index){return _c('div',{key:`${index}-${item.src}`,staticClass:"assets-item",class:{
        plus: item.added === false,
        minus: item.added === true,
        view: item.type === 'view',
      },on:{"click":function($event){return _vm.handlerAsset(item)}}},[_c('AssetsImage',{attrs:{"item":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }